// src/components/PrintOrder.js

const translateOptionType = (type) => {
  switch (type) {
    case "Color":
      return "צבע";
    case "Size":
      return "מידה";
    default:
      return type;
  }
};

export const printOrder = (order, resolveImgSrc) => {
  if (!order) return;

  const products = order.ordersProducts || [];
  const productsPerPage = 18;

  // מחלקים ל"עמודים" בני 20 מוצרים
  const pages = [];
  for (let i = 0; i < products.length; i += productsPerPage) {
    pages.push(products.slice(i, i + productsPerPage));
  }

  const printWindow = window.open("", "", "width=900,height=650");

  printWindow.document.write(`
    <html dir="rtl">
      <head>
        <title>הדפסת הזמנה ${order.id}</title>

        <style>
          body { font-family: Arial, sans-serif; padding: 20px; }
          h2 { margin-bottom: 10px; }
          .section-title { font-weight: bold; margin-top: 20px; font-size: 18px; }

          .page { page-break-after: always; }
          .page:last-child { page-break-after: auto; }

          .products-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 10px;
            margin-top: 10px;
          }

          // .product-item {
          //   border: 1px solid #ccc;
          //   padding: 6px;
          //   border-radius: 4px;
          //   font-size: 14px;
          // }

          // .product-item img {
          //   width: 50px;
          //   height: 50px;
          //   object-fit: cover;
          //   margin-left: 10px;
          //   border-radius: 4px;
          // }


          .product-item {
  border: 1px solid #ccc;
  padding: 8px;
  border-radius: 4px;
  font-size: 14px;

  display: flex;              /* ← חשוב */
  align-items: flex-start;
  gap: 10px;
}

.product-item img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
  flex-shrink: 0;             /* ← שלא יתכווץ */
}

.product-content {
  flex: 1;                    /* ← הטקסט תופס את כל השורה */
}


          .customer-box {
            margin-top: 25px;
            padding: 15px;
            border: 1px solid #999;
            border-radius: 6px;
          }

          .total-box {
            margin-top: 20px;
            padding: 15px;
            border: 2px solid #444;
            border-radius: 6px;
            font-size: 20px;
            font-weight: bold;
            text-align: center;
          }
            .customer-box {
  margin-top: 15px;
  padding: 12px;
  border: 1px solid #999;
  border-radius: 6px;

  display: flex;              /* ← הכל בשורה אחת */
  flex-wrap: wrap;            /* אם אין מקום – ירד שורה יפה */
  gap: 20px;

  font-size: 14px;

  break-inside: avoid;
  page-break-inside: avoid;
}

.customer-item {
  white-space: nowrap;        /* שלא יישבר באמצע */
}

        </style>
      </head>

      <body>
        ${pages
      .map(
        (pageProducts, index) => `
      <div class="page">
        
        <h2>פרטי הזמנה #${order.id} – עמוד ${index + 1}</h2>

        ${index === 0
            ? `
         <div class="customer-box">
  <div class="customer-item"><strong>שם:</strong> ${order.user?.name ?? "לא צוין"}</div>
  <div class="customer-item"><strong>אימייל:</strong> ${order.user?.email ?? "לא צוין"}</div>
  <div class="customer-item"><strong>טלפון:</strong> ${order.user?.phone ?? "לא צוין"}</div>
  <div class="customer-item"><strong>כתובת:</strong> ${order.user?.address ?? "לא צוין"}</div>
</div>

        `
            : ""
          }

        <div class="section-title">מוצרים:</div>

        <div class="products-grid">
      ${pageProducts
            .map((p) => {
              const optionText = p.productOption
                ? ` (${translateOptionType(p.productOption.optionType)}: ${p.productOption.value})`
                : "";

              const basePrice = Number(p.product?.price) || 0;
              const optionPrice = Number(p.productOption?.extraPrice) || 0; // מחיר וריאציה (אצלך מחיר סופי)
              const unitPrice = optionPrice > 0 ? optionPrice : basePrice;

              const amount = Number(p.amount) || 0;
              const lineTotal = unitPrice * amount;

return `
  <div class="product-item">
    <img src="${resolveImgSrc(p.product.image)}" />

    <div class="product-content">
      <strong>${p.product.name}${optionText}</strong><br>
      כמות: ${amount}<br>
      מחיר ליחידה: ${unitPrice.toFixed(2)} ₪<br>
      סה"כ: ${lineTotal.toFixed(2)} ₪
    </div>
  </div>
`;
      })

            .join("")}


        </div>

        ${index === pages.length - 1
            ? `
          <div class="total-box">
            סה"כ לתשלום: ₪${order.totalCost.toFixed(2)}
          </div>
        `
            : ""
          }

      </div>
    `
      )
      .join("")}

      </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
  printWindow.close();
};
